import { useEffect, useMemo } from 'react';
import logo from '../logo.svg';
import './KraCitizenEventPage.css';

const androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.timehive.marlta';
const iosStoreUrl = 'https://apps.apple.com/kr/app/id1532007829';
const adImageUrl =
  'https://s3.ap-northeast-2.amazonaws.com/storage.malta.com/admin/adcontent/1786700389031_912_1561.jpg';

function getDeviceClass() {
  const userAgent = navigator.userAgent || '';

  if (/Android/i.test(userAgent)) return 'os-android';
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'os-ios';
  return '';
}

function KraCitizenEventPage() {
  const deviceClass = useMemo(getDeviceClass, []);

  useEffect(() => {
    document.title = '말타 앱 업데이트 안내';
  }, []);

  return (
    <main className={`kra-citizen-event-page ${deviceClass}`}>
      <div className="kra-citizen-event-wrap">
        <header className="kra-citizen-event-header">
          <img className="kra-citizen-event-logo" alt="말타" src={logo} />
          <h1>
            승마교실을 신청하시려면
            <br />
            최신버전의 말타앱을 설치해주세요
          </h1>

          <div className="kra-citizen-event-actions">
            <a className="kra-citizen-event-button android-cta" href={androidStoreUrl}>
              Play 스토어에서 업데이트
            </a>
            <a className="kra-citizen-event-button ios-cta" href={iosStoreUrl}>
              App Store에서 업데이트
            </a>
          </div>
        </header>

        <img
          className="kra-citizen-event-ad"
          loading="lazy"
          alt="일반시민 대상 승마교실 말중 초급과정 수강생 모집"
          src={adImageUrl}
        />
      </div>
    </main>
  );
}

export default KraCitizenEventPage;
